export const aboutData = {
  brandName: "91蜜桃",
  tagline: "致力于为用户提供安全、稳定、优质的内容访问服务",
  introduction: [
    "91蜜桃是国内领先的在线内容平台，自成立以来始终致力于为用户提供丰富优质的视频内容和流畅稳定的访问体验。平台汇聚了海量高清视频资源，涵盖多个内容领域，满足不同用户的多元化需求。",
    "我们拥有一支专业的技术团队，不断优化平台架构和CDN节点部署，确保全球用户都能享受到极速流畅的访问体验。同时，我们高度重视用户隐私保护和数据安全，采用行业领先的加密技术，为用户营造安全可靠的使用环境。",
    "面对复杂多变的网络环境，91蜜桃建立了完善的入口地址更新机制和备用访问方案，确保用户随时都能找到可用的访问方式。我们的官方导航网站就是为用户提供最新、最全入口信息的重要平台。",
  ],
  values: [
    {
      title: "用户至上",
      description: "始终以用户体验为核心，持续优化平台功能和服务质量。",
      icon: "ri-heart-line",
    },
    {
      title: "安全可靠",
      description: "采用先进的安全技术，全方位保护用户数据和隐私安全。",
      icon: "ri-shield-check-line",
    },
    {
      title: "技术创新",
      description: "不断探索和应用新技术，提升平台性能与访问稳定性。",
      icon: "ri-lightbulb-line",
    },
    {
      title: "内容为王",
      description: "持续丰富内容资源，为用户提供高质量的视频内容服务。",
      icon: "ri-movie-line",
    },
  ],
  reputation: [
    {
      stat: "500万+",
      label: "累计注册用户",
    },
    {
      stat: "99.9%",
      label: "平台可用率",
    },
    {
      stat: "50万+",
      label: "日均活跃用户",
    },
    {
      stat: "4.8/5",
      label: "用户满意度评分",
    },
  ],
  contact: {
    email: "support@91mitao.com",
    responseTime: "24小时内回复",
    workingHours: "周一至周日 9:00 - 21:00",
  },
  timeline: [
    {
      year: "2021",
      title: "平台成立",
      description: "91蜜桃平台正式上线运营，开启内容服务新篇章。",
    },
    {
      year: "2022",
      title: "用户突破100万",
      description: "凭借优质内容和稳定服务，注册用户数突破100万大关。",
    },
    {
      year: "2023",
      title: "技术升级",
      description: "完成核心架构升级，全球CDN节点扩展至10+个国家和地区。",
    },
    {
      year: "2024",
      title: "内容生态扩展",
      description: "内容库扩充至百万级别，覆盖更多内容领域和品类。",
    },
    {
      year: "2025",
      title: "智能推荐上线",
      description: "基于AI的智能推荐系统上线，个性化内容匹配更加精准。",
    },
    {
      year: "2026",
      title: "全面优化",
      description: "移动端体验全面升级，夜间模式等功能上线，用户满意度创新高。",
    },
  ],
};